module.exports = __webpack_public_path__ + "static/cover-1-4d7c5c59f42457741da7d4f1ef3ea827.png";